import { useQuery } from "@tanstack/react-query";
import type {
  IBillDetail,
  IOverviewJointBillService,
} from "@services/overview/types";
import { getBillDetailMeterRules } from "./services";

export const useGetBillDetailMeterRules = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
  billDetailId: IBillDetail["billDetailId"],
) =>
  useQuery({
    queryKey: ["billDetailRules", billDetailId],
    queryFn: () => getBillDetailMeterRules(jointBillServiceId, billDetailId),
    staleTime: Infinity,
  });
